import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';

const initialState = generateReduxKeys({
  restaurants: [],
  pagination: null,
  users: [],
  restaurantAnalytics: {},
});

const restaurantSlice = createSlice({
  name: 'restaurants',
  initialState,
  reducers: {
    setRestaurants: (state, action) => {
      localStorage.setItem('restaurants', JSON.stringify(action.payload));
      state.restaurants = action.payload;
    },
    setRestaurantPagination: (state, action) => {
      state.pagination = action.payload;
    },
    setRestaurantUser: (state, action) => {
      const sanitizedUsers = action.payload?.map((user) => ({
        ...user,
        last_name: user.last_name ?? '',
      }));
      state.users = sanitizedUsers;
    },
    setRestaurantAnalytics: (state, action) => {
      state.restaurantAnalytics = action.payload;
    },
  },
});

export const {
  setRestaurants,
  setRestaurantPagination,
  setRestaurantUser,
  setRestaurantAnalytics,
} = restaurantSlice.actions;

export default restaurantSlice.reducer;
